/**
 * A record's fields, as a definition list.
 *
 * Every detail screen shows the same thing — a grid of labels and values, with
 * free text spanning the full width — so it is defined once here rather than
 * reimplemented per module. The third copy of this markup was what prompted the
 * extraction (Plan Section 8, risk 2: six developers, six house styles).
 *
 * A real `<dl>` with `<dt>`/`<dd>` pairs, not a grid of `<div>`s, so a screen
 * reader announces "Email, meera@example.org" rather than two unrelated strings.
 */

import type { ReactNode } from 'react';
import styles from './DetailList.module.css';

export interface DetailItem {
  label: string;
  /** Already formatted for display — use `orDash` for anything nullable. */
  value: ReactNode;
  /** Span the full width. For notes, addresses, reasons: anything free-text. */
  wide?: boolean;
}

export interface DetailListProps {
  items: DetailItem[];
}

export function DetailList({ items }: DetailListProps) {
  return (
    <dl className={styles.list}>
      {items.map((item) => (
        <div key={item.label} className={item.wide ? styles.itemWide : styles.item}>
          <dt className={styles.term}>{item.label}</dt>
          <dd className={styles.value}>{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
